export default {
  viewBox: "0 0 24 24",
  html: "<path fill-rule=\"evenodd\" d=\"m2 6.27 6.97 6.97L6.5 19h3l1.57-3.66L16.73 21 18 19.73 3.55 5.27 3.27 5zm4-1.09L8.82 8h2.4l-.72 1.68 2.1 2.1L14.21 8H20V5H6z\"/>"
};